import moment from "moment";
import React from "react";

const ALGridReport = ({ reportData, datesOfTheWeek }) => {
  const skillCategories = [
    "Personal Hygiene",
    "House Keeping",
    "Meal Preparation",
    "Shopping",
    "Laundry",
    "Money Management",
    "Healthy Lifestyle",
    "Stress Management",
    "Use of Public Transportation",
    "Medication Management",
    "Behavior Education",
  ];

  const renderHeaderColumn = (d) => {
    return (
      <div key={d} className="col border-end border-2 border-dark text-center">
        <br />
        <br />
        {moment(d).format("dddd")}
        <br />
        <br />
        Date {moment(d).format("L")}
      </div>
    );
  };

  const categoryRow = (
    <div className="row row-cols-8 border-bottom border-dark">
      <div className="col border-end border-2 border-dark fw-bold">
        Category
      </div>
      <div className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">Units</div>
          <div className="col border-end border-dark">Setting</div>
          <div className="col">Progress</div>
        </div>
      </div>
      <div className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">Units</div>
          <div className="col border-end border-dark">Setting</div>
          <div className="col">Progress</div>
        </div>
      </div>
      <div className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">Units</div>
          <div className="col border-end border-dark">Setting</div>
          <div className="col">Progress</div>
        </div>
      </div>
      <div className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">Units</div>
          <div className="col border-end border-dark">Setting</div>
          <div className="col">Progress</div>
        </div>
      </div>
      <div className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">Units</div>
          <div className="col border-end border-dark">Setting</div>
          <div className="col">Progress</div>
        </div>
      </div>
      <div className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">Units</div>
          <div className="col border-end border-dark">Setting</div>
          <div className="col">Progress</div>
        </div>
      </div>
      <div className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">Units</div>
          <div className="col border-end border-dark">Setting</div>
          <div className="col">Progress</div>
        </div>
      </div>
    </div>
  );

  const renderServiceInfo = (data, serviceDate, skillCategory) => {
    if (!data[serviceDate]?.[skillCategory]) {
      return (
        <div key={serviceDate} className="col border-end border-2 border-dark">
          <div className="row">
            <div className="col border-end border-dark">-</div>
            <div className="col border-end border-dark">-</div>
            <div className="col">-</div>
          </div>
        </div>
      );
    }

    return (
      <div key={serviceDate} className="col border-end border-2 border-dark">
        <div className="row">
          <div className="col border-end border-dark">
            {data[serviceDate][`${skillCategory}.units`]}
          </div>
          <div className="col border-end border-dark">
            {data[serviceDate][`${skillCategory}.settings`]}
          </div>
          <div className="col">
            {data[serviceDate][`${skillCategory}.progress`]}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {reportData ? (
        <div className="container-fluid border-start border-top border-2 border-dark">
          <div className="row row-cols-8 border-bottom border-dark fw-bold lh-1">
            <div className="col py-2 border-end border-2 border-dark">
              H0036
              <br />
              Individual = I
              <br />
              <br />
              H0036-HQ
              <br />
              Group = G
            </div>
            {datesOfTheWeek.map(renderHeaderColumn)}
          </div>
          {categoryRow}
          {skillCategories.map((sc) => (
            <div key={sc} className="row row-cols-8 border-bottom border-dark">
              <div className="col border-end border-2 border-dark fw-bold">
                {sc}
              </div>
              {datesOfTheWeek.map((d) => renderServiceInfo(reportData, d, sc))}
            </div>
          ))}
          <div className="row border-bottom border-2 border-dark">
            <div className="col border-end border-2 border-dark fw-bold">
              Total Daily Units
            </div>
            {datesOfTheWeek.map((d) => (
              <div key={d} className="col border-end border-2 border-dark">
                {reportData[d]?.totalUnits}
              </div>
            ))}
          </div>
          <div className="row border-bottom border-end border-2 border-dark">
            <div className="col clearfix fw-bold">
              <div className="float-start">
                <span className="me-3">Setting Codes:</span>
                <span className="me-3">1 = Home</span>
                <span className="me-3">2 = School</span>
                <span className="me-3">3 = Treatment Facility</span>
                <span className="me-3">4 = Community</span>
                <span className="me-3">5 = Other</span>
                <br />
                <br />
                <span className="me-3">Progress Codes:</span>
                <span className="me-3">A = Progress Noted</span>
                <span className="me-3">B = Progress Maintained</span>
                <span className="me-3">C = Regression</span>
                <br />
                <br />
                <span>
                  **************SERVICES PROVIDED MUST BE CONSISTENT WITH DHR's
                  ISP
                </span>
              </div>
              <div className="float-end">
                <legend className="border border-2 border-dark mt-2 px-2">
                  <table style={{ fontSize: "12pt" }}>
                    <tbody>
                      <tr>
                        <td>
                          <u>UNITS</u>
                        </td>
                        <td></td>
                        <td>
                          <u>TIME</u>
                        </td>
                        <td>
                          <u>UNITS</u>
                        </td>
                        <td></td>
                        <td>
                          <u>TIME</u>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          1 unit
                          <br />2 units
                          <br />3 units
                          <br />4 units
                          <br />5 units
                          <br />6 units
                          <br />7 units
                          <br />8 units
                          <br />9 units
                          <br />
                          10 units
                          <br />
                        </td>
                        <td>
                          =<br />=<br />=<br />=<br />=<br />=<br />=<br />=
                          <br />=
                          <br />=<br />
                        </td>
                        <td className="pe-4">
                          15 minutes
                          <br />
                          30 minutes
                          <br />
                          45 minutes
                          <br />1 hour
                          <br />1 hour &amp; 15 minutes
                          <br />1 hour &amp; 30 minutes
                          <br />1 hour &amp; 45 minutes
                          <br />2 hours
                          <br />2 hours &amp; 15 minutes
                          <br />2 hours &amp; 30 minutes
                        </td>
                        <td>
                          11 units
                          <br />
                          12 units
                          <br />
                          13 units
                          <br />
                          14 units
                          <br />
                          15 units
                          <br />
                          16 units
                          <br />
                          17 units
                          <br />
                          18 units
                          <br />
                          19 units
                          <br />
                          20 units
                        </td>
                        <td>
                          =<br />=<br />=<br />=<br />=<br />=<br />=<br />=
                          <br />=
                          <br />=<br />
                        </td>
                        <td>
                          2 hours &amp; 45 minutes
                          <br />3 hours
                          <br />3 hours &amp; 15 minutes
                          <br />3 hours &amp; 30 minutes
                          <br />3 hours &amp; 45 minutes
                          <br />4 hours
                          <br />4 hours &amp; 15 minutes
                          <br />4 hours &amp; 30 minutes
                          <br />4 hours &amp; 45 minutes
                          <br />5 hours
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </legend>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ALGridReport;
